import { render, staticRenderFns } from "./CustomerRelink.vue?vue&type=template&id=700dc8f5&scoped=true&"
import script from "./CustomerRelink.vue?vue&type=script&lang=js&"
export * from "./CustomerRelink.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRelink.vue?vue&type=style&index=0&id=700dc8f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700dc8f5",
  null
  
)

export default component.exports